import { PropertyTool } from './types'

/** Type guard, returns true if a given string is a valid tool. */
export const stringIsValidTool = (tool: string | null): tool is PropertyTool =>
  typeof tool === 'string' && tool in PropertyTool
